import { PipeableObject } from '../base/pipeable/pipeable_object.js';
import { ReviewBaseMixin } from './review_base_mixin.js';

class Review extends ReviewBaseMixin(PipeableObject) {
  setData(data) {
    this.set(data);
  }
}

export { Review };
